// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
    factory('travelManagerAssignment', ['$http', '$q', 'obexConstant', 'authService',
      ($http, $q, obexConstant, authService) => {
        return {
          getTravelManagerOrganizationsById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlTravelManagerOrganizations}/TravelManagerOrganizationDetails/Organization/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },

          addTravelManagerOrganizations(travelManagerOrganizationList) {
            const promises = _.map(travelManagerOrganizationList, travelManagerOrganization => {
              return authService.getAuthorizationHeader().then(authHeader => {
                const url = `${obexConstant.urlTravelManagerOrganizations}/CreateTravelManagerOrganizations`;
                const postData = {
                  Id: travelManagerOrganization.Id,
                  MemberId: travelManagerOrganization.MemberId,
                  OrganizationId: travelManagerOrganization.OrganizationId,
                };
                return $http.post(url, postData, {
                  headers: authHeader,
                });
              });
            });
            return $q.all(promises);
          },

          deleteTravelManagerOrganizations(travelManagerOrganizationIdList) {
            const promises = _.map(travelManagerOrganizationIdList, travelManagerOrganization => {
              return authService.getAuthorizationHeader().then(authHeader => {
                const url =
                  `${obexConstant.urlTravelManagerOrganizations}/DeleteTravelManagerOrganizations/id/${travelManagerOrganization.TravelManagerOrganizationId}`;
                return $http.delete(url, {
                  headers: authHeader,
                });
              });
            });
            return $q.all(promises);
          },
        };
      },
    ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/travelManagerAssignment.service.js